import React from 'react';
import {FieldEditableProps} from "../../../../proto/render/editable";
import {FieldControlViewProps} from "../../../../render/control-view";
import FieldViewForUser_ControlViewNotEmpty from "../components/control-view/value-not-empty";
import FieldViewForUser_ControlViewEmpty from "../components/control-view/value-empty";
import FieldViewForUser_PopoverMenu from "../components/popover/popover";

type State = {
    initialPropsValue   : any
    currentOption       : any
    showPopover         : boolean
}

// const debug = "FieldViewForUser_ControlView"
const debug = false

export default class FieldViewForUser_ControlView extends React.Component<FieldControlViewProps, State> {

    private previousOption: any

    constructor(props:FieldEditableProps) {
        super(props)

        const value = this.props.model[this.props.field.fieldId]

        this.state = {
            initialPropsValue: value, // required to check if currentOption update needed on props changed
            currentOption: props.field._getOption(value),
            showPopover: false,
        }
    }

    static getDerivedStateFromProps(props:any, state:any) {
        const value = props.model[props.field.fieldId]

        if (value !== state.initialPropsValue) {
            return {
                initialPropsValue   : value,
                currentOption       : props.field._getOption(value)
            }
        }

        return null // no changes
    }

    showPopover = () => {
        if (!this.state.showPopover && !this.props.disabled) this.setState({showPopover: true})
    }
    hidePopover = () => {if (this.state.showPopover) this.setState({showPopover: false})}

    onOptionClick = (option:any) => {

        this.previousOption = this.state.currentOption;
        if (!option || _.isNil(option.value)) option = null;

        this.setState({
            currentOption: option
        }, () => {
            // if (this.props.onChange) this.props.onChange(_.get(option, 'value', null), this.onCancelChange);
            if (this.props.onChange) this.props.onChange(_.get(option, 'value', null));
            this.hidePopover()
        });
    }

    onReset = ()=>{
        if (this.props.onChange && !this.props.disabled) this.props.onChange(gd.session.me.id)
    }

    onCancelChange = () => {
        this.setState({
            currentOption: this.previousOption
        });
    }

    render() {
        const {field} = this.props;

        const classes = Classes(this.props.className, {
            'show-popover' : this.state.showPopover,
        });

        const hasValue = this.state.currentOption && (field.hasOptionWithNullValue || !_.isNil(this.state.currentOption.value))

        debug && console.log(debug, 'render', this.props.params)

        // need check value because of none
        if (hasValue) {
            return (
                <FieldViewForUser_ControlViewNotEmpty className = {classes}
                                                      field     = {this.props.field}
                                                      disabled  = {this.props.disabled}
                                                      option    = {this.state.currentOption}
                                                      model     = {this.props.model}
                                                      params    = {this.props.params}
                                                      onReset   = {this.onReset}
                                                      onClick   = {this.showPopover}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                </FieldViewForUser_ControlViewNotEmpty>
            );
        }

        // No value
        return (
            <FieldViewForUser_ControlViewEmpty className    = {classes}
                                               field        = {this.props.field}
                                               disabled     = {this.props.disabled}
                                               model        = {this.props.model}
                                               params       = {this.props.params}
                                               onClick      = {this.showPopover}>
                {this.state.showPopover && <FieldViewForUser_PopoverMenu {...this.props} parent={this} />}
            </FieldViewForUser_ControlViewEmpty>
        );
    }
}
